module.exports = __webpack_public_path__ + "img/art-37.373b70d1.png";